(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-eselsmilch"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var pills   = document.querySelectorAll('#hn-col-fpills .hn-col-fpill');
    var cards   = document.querySelectorAll('#hn-col-cards .hn-col-card');
    var countEl = document.getElementById('hn-col-pcount');

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('active'); });
        this.classList.add('active');
        var tag     = this.getAttribute('data-tag');
        var visible = 0;
        cards.forEach(function (card) {
          var tags = card.getAttribute('data-tags') || '';
          var show = tag === 'all' || tags.split(',').some(function(t){ return t.trim() === tag; });
          card.style.display = show ? '' : 'none';
          if (show) visible++;
        });
        if (countEl) countEl.textContent = visible + ' ' + (visible === 1 ? 'Produkt' : 'Produkte');
      });
    });

    document.querySelectorAll('.hn-col-atc-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.hn-col-atc-btn');
        var id  = form.querySelector('input[name="id"]').value;
        var qty = parseInt(form.querySelector('input[name="quantity"]').value) || 1;
        btn.textContent       = '✓ Hinzugefügt!';
        btn.style.background  = '#eef3e8';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: qty })
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () {
            btn.textContent      = 'In den Warenkorb';
            btn.style.background = '';
          }, 2000);
        }).catch(function () { form.submit(); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bandnudeln"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Sticky bar: position below theme header and show on scroll
    var sticky = document.getElementById('hn-sticky');
    var atcBtn = document.getElementById('hn-add-to-cart');

    function positionSticky() {
      var header = document.querySelector('.shopify-section-group-header-group, .header-wrapper, header');
      var hh = header ? header.getBoundingClientRect().height : 56;
      sticky.style.top = hh + 'px';
    }

    function onScroll() {
      if (!atcBtn) return;
      var rect = atcBtn.getBoundingClientRect();
      if (rect.bottom < 0) {
        sticky.classList.add('visible');
        sticky.setAttribute('aria-hidden', 'false');
      } else {
        sticky.classList.remove('visible');
        sticky.setAttribute('aria-hidden', 'true');
      }
    }

    positionSticky();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', positionSticky);

    // Qty counter
    window.hnChangeQty = function(d) {
      var el = document.getElementById('hn-qty');
      var v = Math.max(1, parseInt(el.textContent) + d);
      el.textContent = v;
      document.getElementById('hn-qty-input').value = v;
    };

    // Variant update
    window.hnUpdateVariant = function(sel) {
      var opt = sel.options[sel.selectedIndex];
      var price = opt.getAttribute('data-price');
      document.getElementById('hn-variant-id').value = sel.value;
      document.getElementById('hn-price').textContent = price;
      document.getElementById('hn-sticky-price').textContent = price;
    };

    // Accordion
    window.hnToggleAcc = function(btn) {
      var body = btn.nextElementSibling;
      var isOpen = body.classList.contains('open');
      document.querySelectorAll('.hn-acc-body').forEach(function(b){ b.classList.remove('open'); });
      document.querySelectorAll('.hn-acc-head').forEach(function(b){ b.classList.remove('open'); });
      if (!isOpen) {
        body.classList.add('open');
        btn.classList.add('open');
      }
    };

    // Thumbnail image swap
    window.hnSetImage = function(src, thumb) {
      var img = document.getElementById('hn-featured-img');
      if (img) img.src = src;
      document.querySelectorAll('.hn-thumb').forEach(function(t){ t.classList.remove('active'); });
      thumb.classList.add('active');
    };

    // Sticky bar add-to-cart
    window.hnStickyAddToCart = function() {
      var form = document.getElementById('hn-product-form');
      if (form) form.submit();
    };

    // AJAX cart with fallback
    var form = document.getElementById('hn-product-form');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var id = document.getElementById('hn-variant-id').value;
        var qty = parseInt(document.getElementById('hn-qty-input').value) || 1;
        var btn = document.getElementById('hn-add-to-cart');
        btn.textContent = '✓ Hinzugefügt!';
        btn.style.background = '#27ae60';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: qty })
        }).then(function() {
          setTimeout(function() {
            btn.textContent = '🛒 In den Warenkorb';
            btn.style.background = '';
          }, 2000);
          // Trigger cart refresh if theme supports it
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }).catch(function() {
          form.submit();
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
